// import { MainLayout } from "../layout/MainLayout";
// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Card,
//   FormInput,
//   Button,
//   Alert,
//   FormGroup,
// } from "../ui/base-components";

// const ResetPassword = () => {
//   const apiRoot = process.env.REACT_APP_API_ROOT_OPERATIONAL;
//   const [users, setUsers] = useState([]);
//   const [formData, setFormData] = useState({
//     selectedUserId: "",
//     newPassword: "",
//     confirmPassword: "",
//     userSearchQuery: "",
//   });
//   const [message, setMessage] = useState({ type: "", text: "" });

//   // Debounce function
//   const debounce = (func, delay) => {
//     let timeoutId;
//     return (...args) => {
//       clearTimeout(timeoutId);
//       timeoutId = setTimeout(() => func(...args), delay);
//     };
//   };

//   // Fetch Users
//   const fetchUsers = useCallback(
//     async (query = "") => {
//       try {
//         if (query.length < 3) {
//           setUsers([]);
//           return;
//         }

//         const response = await fetch(`${apiRoot}/api/user?search=${query}`, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         });
//         const data = await response.json();
//         const formattedUsers = data.map((user) => ({
//           value: user.id,
//           label: user.email,
//         }));

//         setUsers(formattedUsers);
//       } catch (error) {
//         setMessage({ type: "error", text: "Error searching users" });
//       }
//     },
//     [apiRoot]
//   );

//   // Debounced search function
//   const debouncedUserSearch = useCallback(
//     debounce((query) => {
//       if (query.length >= 3) {
//         fetchUsers(query);
//       } else {
//         setUsers([]);
//       }
//     }, 300),
//     [fetchUsers]
//   );

//   // Handle input changes
//   const handleChange = (e) => {
//     const { id, value } = e.target;
//     setFormData((prev) => {
//       // If it's the user search query, trigger search
//       if (id === "userSearchQuery") {
//         debouncedUserSearch(value);
//       }

//       return {
//         ...prev,
//         [id]: value,
//         // Reset selected user if search query changes
//         ...(id === "userSearchQuery" && { selectedUserId: "" }),
//       };
//     });
//   };

//   // Handle user selection
//   const handleUserSelect = (userId) => {
//     setFormData((prev) => ({
//       ...prev,
//       selectedUserId: userId,
//       userSearchQuery: users.find((user) => user.value === userId)?.label || "",
//     }));
//     setUsers([]); // Clear search results after selection
//   };

//   // Submit handler
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setMessage({ type: "", text: "" });

//     if (!formData.selectedUserId) {
//       setMessage({ type: "error", text: "Please select a user" });
//       return;
//     }

//     if (formData.newPassword !== formData.confirmPassword) {
//       setMessage({ type: "error", text: "Passwords do not match" });
//       return;
//     }

//     try {
//       const formPayload = new FormData();
//       formPayload.append("newPassword", formData.newPassword);
//       formPayload.append("confirmPassword", formData.confirmPassword);

//       const response = await fetch(
//         `${apiRoot}/api/user/${formData.selectedUserId}/reset-password`,
//         {
//           method: "PUT",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//           body: formPayload,
//         }
//       );

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.error || "Failed to reset password");
//       }

//       setMessage({ type: "success", text: "Password reset successfully!" });
//       setFormData({
//         selectedUserId: "",
//         newPassword: "",
//         confirmPassword: "",
//         userSearchQuery: "",
//       });
//     } catch (error) {
//       setMessage({
//         type: "error",
//         text: error.message || "Failed to reset password",
//       });
//     }
//   };

//   return (
//     <MainLayout>
//       <div className="p-6 mt-4">
//         <div className="max-w-md mx-auto">
//           <Card>
//             <div className="space-y-6">
//               <div>
//                 <h2 className="text-2xl font-bold text-gray-900">
//                   Reset Password
//                 </h2>
//                 <p className="mt-1 text-sm text-gray-600">
//                   Change the password for a selected user.
//                 </p>
//               </div>

//               {message.text && (
//                 <Alert type={message.type} message={message.text} />
//               )}

//               <form onSubmit={handleSubmit} className="space-y-6">
//                 <FormGroup>
//                   <div className="space-y-2">
//                     <FormInput
//                       id="userSearchQuery"
//                       label="Search User"
//                       type="text"
//                       placeholder="Type at least 3 characters to search"
//                       value={formData.userSearchQuery}
//                       onChange={handleChange}
//                     />

//                     {users.length > 0 && (
//                       <div className="border border-gray-300 rounded-md shadow-sm max-h-48 overflow-y-auto">
//                         {users.map((user) => (
//                           <div
//                             key={user.value}
//                             onClick={() => handleUserSelect(user.value)}
//                             className="px-3 py-2 hover:bg-gray-100 cursor-pointer 
//                               transition-colors duration-200 
//                               border-b border-gray-200 last:border-b-0"
//                           >
//                             {user.label}
//                           </div>
//                         ))}
//                       </div>
//                     )}

//                     {formData.selectedUserId && (
//                       <div className="mt-2 text-sm text-gray-700">
//                         Selected User: {formData.userSearchQuery}
//                       </div>
//                     )}
//                   </div>

//                   <FormInput
//                     id="newPassword"
//                     label="New Password"
//                     type="password"
//                     value={formData.newPassword}
//                     onChange={handleChange}
//                     required
//                   />

//                   <FormInput
//                     id="confirmPassword"
//                     label="Confirm Password"
//                     type="password"
//                     value={formData.confirmPassword}
//                     onChange={handleChange}
//                     required
//                   />
//                 </FormGroup>

//                 <Button
//                   type="submit"
//                   className="w-full"
//                   disabled={!formData.selectedUserId}
//                 >
//                   Reset Password
//                 </Button>
//               </form>
//             </div>
//           </Card>
//         </div>
//       </div>
//     </MainLayout>
//   );
// };

// export default ResetPassword;
import { MainLayout } from "../layout/MainLayout";
import React, { useState, useEffect, useCallback } from "react";
import {
  Key,
  Search,
  User,
  Lock,
  Eye,
  EyeOff,
  CheckCircle2,
  AlertCircle,
  Loader,
  Shield
} from "lucide-react";

const ResetPassword = () => {
  const apiRoot = process.env.REACT_APP_API_ROOT_OPERATIONAL;
  const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState({
    selectedUserId: "",
    newPassword: "",
    confirmPassword: "",
    userSearchQuery: "",
  });
  const [message, setMessage] = useState({ type: "", text: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Debounce function
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  // Fetch Users
  const fetchUsers = useCallback(
    async (query = "") => {
      try {
        if (query.length < 3) {
          setUsers([]);
          setIsSearching(false);
          return;
        }

        setIsSearching(true);
        const response = await fetch(`${apiRoot}/api/user?search=${query}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });
        const data = await response.json();
        const formattedUsers = data.map((user) => ({
          value: user.id,
          label: user.email,
        }));

        setUsers(formattedUsers);
      } catch (error) {
        setMessage({ type: "error", text: "Error searching users" });
      } finally {
        setIsSearching(false);
      }
    },
    [apiRoot]
  );

  // Debounced search function
  const debouncedUserSearch = useCallback(
    debounce((query) => {
      if (query.length >= 3) {
        fetchUsers(query);
      } else {
        setUsers([]);
        setIsSearching(false);
      }
    }, 300),
    [fetchUsers]
  );

  // Handle input changes
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => {
      // If it's the user search query, trigger search
      if (id === "userSearchQuery") {
        if (value.length >= 3) {
          setIsSearching(true);
        }
        debouncedUserSearch(value);
      }

      return {
        ...prev,
        [id]: value,
        // Reset selected user if search query changes
        ...(id === "userSearchQuery" && { selectedUserId: "" }),
      };
    });
  };

  // Handle user selection
  const handleUserSelect = (userId) => {
    setFormData((prev) => ({
      ...prev,
      selectedUserId: userId,
      userSearchQuery: users.find((user) => user.value === userId)?.label || "",
    }));
    setUsers([]); // Clear search results after selection
    setIsSearching(false);
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: "", text: "" });

    if (!formData.selectedUserId) {
      setMessage({ type: "error", text: "Please select a user" });
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setMessage({ type: "error", text: "Passwords do not match" });
      return;
    }

    if (formData.newPassword.length < 6) {
      setMessage({ type: "error", text: "Password must be at least 6 characters long" });
      return;
    }

    setIsLoading(true);
    try {
      const formPayload = new FormData();
      formPayload.append("newPassword", formData.newPassword);
      formPayload.append("confirmPassword", formData.confirmPassword);

      const response = await fetch(
        `${apiRoot}/api/user/${formData.selectedUserId}/reset-password`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: formPayload,
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Failed to reset password");
      }

      setMessage({ type: "success", text: "Password reset successfully!" });
      setFormData({
        selectedUserId: "",
        newPassword: "",
        confirmPassword: "",
        userSearchQuery: "",
      });
    } catch (error) {
      setMessage({
        type: "error",
        text: error.message || "Failed to reset password",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MainLayout>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-8">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Page Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-orange-600 to-amber-600 rounded-2xl mb-6 shadow-lg">
              <Key className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-4xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-4">
              Reset Password
            </h1>
            <p className="text-lg text-slate-600 max-w-xl mx-auto">
              Change the password for a selected user in the system
            </p>
          </div>

          {/* Main Form Card */}
          <div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden">
            {/* Card Header */}
            <div className="bg-gradient-to-br from-orange-600 to-amber-600 p-6 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
              <div className="relative z-10">
                <div className="flex items-center gap-3">
                  <div className="inline-flex items-center justify-center w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl">
                    <Key className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h2 className="text-xl font-bold text-white">Password Management</h2>
                    <p className="text-white/80 text-sm">Search for a user and set a new password</p>
                  </div>
                </div>
              </div>
              
              {/* Decorative Elements */}
              <div className="absolute -top-8 -right-8 w-24 h-24 bg-white/10 rounded-full"></div>
              <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-white/10 rounded-full"></div>
            </div>

            {/* Card Content */}
            <div className="p-8">
              {/* Alert Messages */}
              {message.text && (
                <div className={`mb-6 p-4 rounded-xl border flex items-center gap-3 ${
                  message.type === "success" 
                    ? "bg-green-50 border-green-200 text-green-700" 
                    : "bg-red-50 border-red-200 text-red-700"
                }`}>
                  {message.type === "success" ? (
                    <CheckCircle2 className="w-5 h-5 flex-shrink-0" />
                  ) : (
                    <AlertCircle className="w-5 h-5 flex-shrink-0" />
                  )}
                  <p className="text-sm font-medium">{message.text}</p>
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-6">
                {/* User Search */}
                <div>
                  <label
                    htmlFor="userSearchQuery"
                    className="block text-sm font-semibold text-slate-700 mb-2"
                  >
                    Search User
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Search className="h-5 w-5 text-slate-400" />
                    </div>
                    <input
                      type="text"
                      id="userSearchQuery"
                      value={formData.userSearchQuery}
                      onChange={handleChange}
                      className="w-full pl-10 pr-10 py-3 border border-slate-300 rounded-xl focus:ring-2 
                        focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 bg-slate-50 focus:bg-white"
                      placeholder="Type at least 3 characters to search users..."
                    />
                    {isSearching && (
                      <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                        <Loader className="h-5 w-5 text-slate-400 animate-spin" />
                      </div>
                    )}
                  </div>
                  <p className="text-sm text-slate-500 mt-1">
                    Enter at least 3 characters to start searching
                  </p>
                </div>

                {/* Search Results */}
                {users.length > 0 && (
                  <div className="border border-slate-200 rounded-xl shadow-sm overflow-hidden">
                    <div className="bg-slate-50 px-4 py-2 border-b border-slate-200">
                      <span className="text-sm font-semibold text-slate-700">Search Results</span>
                    </div>
                    <div className="max-h-48 overflow-y-auto">
                      {users.map((user, index) => (
                        <div
                          key={user.value}
                          onClick={() => handleUserSelect(user.value)}
                          className={`px-4 py-3 hover:bg-slate-50 cursor-pointer transition-colors duration-200 
                            flex items-center gap-3 ${
                              index !== users.length - 1 ? 'border-b border-slate-100' : ''
                            }`}
                        >
                          <User className="w-4 h-4 text-slate-400" />
                          <span className="text-slate-700">{user.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Selected User Display */}
                {formData.selectedUserId && (
                  <div className="bg-orange-50 border border-orange-200 rounded-xl p-4">
                    <h3 className="text-sm font-semibold text-orange-700 mb-2 flex items-center gap-2">
                      <User className="w-4 h-4" />
                      Selected User
                    </h3>
                    <div className="bg-white rounded-lg p-3 border border-orange-200">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center">
                          <User className="w-4 h-4 text-orange-600" />
                        </div>
                        <div>
                          <p className="font-medium text-orange-800">{formData.userSearchQuery}</p>
                          <p className="text-sm text-orange-600">Ready for password reset</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* New Password */}
                <div>
                  <label
                    htmlFor="newPassword"
                    className="block text-sm font-semibold text-slate-700 mb-2"
                  >
                    New Password
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Lock className="h-5 w-5 text-slate-400" />
                    </div>
                    <input
                      type={showNewPassword ? "text" : "password"}
                      id="newPassword"
                      value={formData.newPassword}
                      onChange={handleChange}
                      className="w-full pl-10 pr-12 py-3 border border-slate-300 rounded-xl focus:ring-2 
                        focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 bg-slate-50 focus:bg-white"
                      placeholder="Enter new password"
                      required
                    />
                    <button
                      type="button"
                      onClick={() => setShowNewPassword(!showNewPassword)}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-slate-600"
                    >
                      {showNewPassword ? (
                        <EyeOff className="h-5 w-5" />
                      ) : (
                        <Eye className="h-5 w-5" />
                      )}
                    </button>
                  </div>
                </div>

                {/* Confirm Password */}
                <div>
                  <label
                    htmlFor="confirmPassword"
                    className="block text-sm font-semibold text-slate-700 mb-2"
                  >
                    Confirm Password
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Lock className="h-5 w-5 text-slate-400" />
                    </div>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      id="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      className="w-full pl-10 pr-12 py-3 border border-slate-300 rounded-xl focus:ring-2 
                        focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 bg-slate-50 focus:bg-white"
                      placeholder="Confirm new password"
                      required
                    />
                    <button
                      type="button"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-slate-600"
                    >
                      {showConfirmPassword ? (
                        <EyeOff className="h-5 w-5" />
                      ) : (
                        <Eye className="h-5 w-5" />
                      )}
                    </button>
                  </div>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={!formData.selectedUserId || isLoading}
                  className="group w-full py-4 px-6 bg-gradient-to-r from-orange-600 to-amber-600 hover:from-orange-700 hover:to-amber-700 
                    text-white rounded-xl font-semibold transition-all duration-200 flex items-center justify-center gap-3
                    disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                >
                  {isLoading ? (
                    <>
                      <Loader className="w-5 h-5 animate-spin" />
                      Resetting Password...
                    </>
                  ) : (
                    <>
                      <Key className="w-5 h-5 group-hover:scale-110 transition-transform duration-200" />
                      Reset Password
                    </>
                  )}
                </button>
              </form>

              {/* Security Information */}
              <div className="mt-8 p-4 bg-slate-50 rounded-xl border border-slate-200">
                <h3 className="text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2">
                  <Shield className="w-4 h-4 text-blue-600" />
                  Security Guidelines
                </h3>
                <div className="grid md:grid-cols-2 gap-2 text-sm text-slate-600">
                  <div className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 bg-orange-600 rounded-full"></div>
                    <span>Use a strong, unique password</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 bg-orange-600 rounded-full"></div>
                    <span>Minimum 6 characters required</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 bg-orange-600 rounded-full"></div>
                    <span>User will need to use this new password</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 bg-orange-600 rounded-full"></div>
                    <span>Consider informing the user securely</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ResetPassword;